export const initListRestaurantOption = data => ({
  type: 'INIT_LIST_RESTAURANT_OPTION',
  payload: data,
});

